import { useState } from "react";

export const useFechaActual = () => {
  const obtenerFechaActual = () => {
    const hoy = new Date();
    const year = hoy.getFullYear();
    const month = String(hoy.getMonth() + 1).padStart(2, "0");
    const day = String(hoy.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // 👇 inicializa con la fecha actual directamente
  const [fecha, setFecha] = useState(obtenerFechaActual);

  const capturarFecha = () => setFecha(obtenerFechaActual());

  const calcularDiferenciaDias = (fechaComparar) => {
    if (!fechaComparar || !fecha) return null;

    const fechaActualDate = new Date(fecha);
    const fechaCompararDate = new Date(fechaComparar);

    fechaActualDate.setHours(0, 0, 0, 0);
    fechaCompararDate.setHours(0, 0, 0, 0);

    const diffTime = fechaCompararDate - fechaActualDate;
    return diffTime / (1000 * 60 * 60 * 24);
  };

  return { fecha, actualizarFecha: capturarFecha, calcularDiferenciaDias };
};
